import Vue from 'vue'
import App from '@/App'
import mixins from '@/helpers/mixins'
import { router } from '@/router'
import '@/assets/css/main.scss'
import 'font-awesome/css/font-awesome.css'

import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import 'vuetify/dist/vuetify.min.css'

import 'vue-resize/dist/vue-resize.css'

import MetaButton from '@/components/widgets/button/MetaButton'
// import { ContentLoader } from 'vue-content-loader'
import FormLoader from '@/components/widgets/loading/FormLoader'
import ButtonState from '@/components/widgets/button/ButtonState'
import mixinConverterLanguage from '@/helpers/languageConvert'

import i18n from '@/i18n/i18n'

import moment from 'moment'
import VeeValidate from 'vee-validate'
import caValidationMessages from 'vee-validate/dist/locale/ca'
import enValidationMessages from 'vee-validate/dist/locale/en'
import esValidationMessages from 'vee-validate/dist/locale/es'
import VueAnalytics from 'vue-analytics'
import VueCurrencyFilter from 'vue-currency-filter'
import VueResize from 'vue-resize'
import VueRx from 'vue-rx'
import VueScrollTo from 'vue-scrollto'
import Vuetify from 'vuetify'
import ca from 'vuetify/es5/locale/ca'
import de from 'vuetify/es5/locale/de'
import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'
import it from 'vuetify/es5/locale/it'
import DatetimePicker from 'vuetify-datetime-picker'
import 'moment/locale/es'
import 'moment/locale/ca'
import 'moment/locale/it'

import IgTextField from '@/components/widgets/Input/IgTextField'
import IgTextFieldNumber from '@/components/widgets/Input/IgTextFieldNumber'
import ButtonConfirm from '@/components/widgets/button/ButtonConfirm'

import rules from '@/helpers/vuetifyRules'
import store from '@/store/store'

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

Vue.component('IgTextField', IgTextField)
Vue.component('IgTextFieldNumber', IgTextFieldNumber)
Vue.component('MetaButton', MetaButton)
Vue.component('ButtonState', ButtonState)
Vue.component('FormLoader', FormLoader)
Vue.component('ButtonConfirm', ButtonConfirm)

Vue.use(VueRx)
Vue.use(i18n)
Vue.use(DatetimePicker)
Vue.use(VueScrollTo, {
  offset: -50,
})

Vue.use(VueResize)

let locale = localStorage.getItem('locale') || 'es'
if (!localStorage.getItem('locale')) {
  let iso = navigator.language || navigator.userLanguage
  locale = iso.split('-')[0]
  localStorage.setItem('locale', locale)
  localStorage.setItem('iso', iso)
  i18n.locale = locale
}

Vue.use(Vuetify, {
  theme: {
    primary: '#00A82D',
    secondary: '#00A82B',
    accent: '#454545',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
  options: {
    customProperties: true,
  },
  lang: {
    locales: { es, en, ca, it, de },
    current: locale,
  },
})
moment.locale(locale)
Vue.use(VeeValidate, {
  iconfont: 'md',
  i18n,
  dictionary: {
    es: esValidationMessages,
    en: enValidationMessages,
    ca: caValidationMessages,
  },
})

Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'back',
  symbolSpacing: true,
})
Vue.filter('capitalize', function (value = '') {
  if (!value || typeof value !== 'string') return value
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.mixin(mixins)
Vue.mixin(rules)
Vue.mixin(mixinConverterLanguage)
Vue.mixin({
  data() {
    return {
      defaultValues: {
        imageUrl: process.env.VUE_APP_IMAGE_URL,
        languageRequire: process.env.VUE_APP_LANGUAGE_REQUIRE,
        videoUrl: process.env.VUE_APP_VIDEO_URL,
        apiUrl: process.env.VUE_APP_API_URL,
        url: process.env.VUE_APP_URL,
      },
    }
  },
})
store.dispatch('languages/fetchList')
store.dispatch('auth/refreshPermissions')

Vue.config.errorHandler = (err) => {
  console.log('Exception: ', err)
}
if (process.env.VUE_APP_URL === 'admin.fbase.tv') {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_KEY,
    router,
    autoTracking: {
      exception: true,
    },
    debug: {
      enable: false, // !isProd
      sendHitTask: true, // isProd
    },
  })
}

/* eslint-disable-next-line no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: (h) => h(App),
})
